const SWIPER_MODULE_URL = 'https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs';

class MediaSlider extends HTMLElement {
    connectedCallback() {
        if (!('IntersectionObserver' in window)) {
            this.initSwiper();
            return;
        }

        this.intersectionObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;

            this.intersectionObserver.disconnect();
            this.initSwiper();
        }, { rootMargin: '600px 0px' });

        this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.swiper?.destroy(true, true);
        this.swiper = null;
    }

    getSettings() {
        const configEl = this.querySelector('[data-media-slider-settings]');
        if (!configEl) return null;

        return JSON.parse(configEl.textContent);
    }

    async initSwiper() {
        if (this.swiper || this.isLoading) return;

        const settings = this.getSettings();
        if (!settings) return;

        this.isLoading = true;

        try {
            const { default: Swiper } = await import(SWIPER_MODULE_URL);
            if (!this.isConnected) return;

            this.swiper = new Swiper(this, {
                slidesPerView: settings.slidesPerViewMobile,
                spaceBetween: settings.spaceBetweenMobile,
                loop: false,
                grabCursor: true,

                autoplay: settings.autoplay
                    ? {
                        delay: settings.autoplayDelay * 1000,
                        disableOnInteraction: false,
                    }
                    : false,

                pagination: {
                    el: this.querySelector('.swiper-pagination'),
                    clickable: true,
                    dynamicBullets: true,
                },

                breakpoints: {
                    768: {
                        slidesPerView: settings.slidesPerViewTablet,
                        spaceBetween: settings.spaceBetween
                    },
                    1200: {
                        slidesPerView: settings.slidesPerView,
                        spaceBetween: settings.spaceBetween
                    }
                },
            });
        } catch (error) {
            console.error('Unable to initialize media slider', error);
        } finally {
            this.isLoading = false;
        }
    }
}

if (!customElements.get('media-slider')) {
    customElements.define('media-slider', MediaSlider);
}
